module.exports = __webpack_public_path__ + "static/img/3.c762b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/3.png
// module id = OwyU
// module chunks = 0